module.exports = __webpack_public_path__ + "static/media/dummies.2942bfab.pdf";